var map = {
	"./": 10589,
	"./AcceptableIcon.svg": 73106,
	"./ActiveProjects.svg": 18321,
	"./AddCompoundIcon.svg": 70652,
	"./ArcBottomRightBrown.svg": 8498,
	"./ArcBottomRightRed.svg": 10291,
	"./ArcBottomRightWhite.svg": 98881,
	"./ArcTopLeftBrown.svg": 10659,
	"./ArcTopLeftRed.svg": 93418,
	"./ArcTopLeftWhite.svg": 68628,
	"./ArrowRightWithTail.svg": 62824,
	"./AttachmentsIcon.svg": 25396,
	"./AuditsAndVisits.svg": 55166,
	"./BackButtonBlack.svg": 49159,
	"./BrownDeleteButton.svg": 54324,
	"./Calender.svg": 56759,
	"./CasePackIconRed.svg": 57508,
	"./CertificateAndDocuments.svg": 19403,
	"./CloseButton.svg": 3281,
	"./Copy.svg": 15526,
	"./CreateProduct.svg": 13840,
	"./DateIcon.svg": 28446,
	"./DeleteIcon.svg": 32383,
	"./DesignArtwork.svg": 42163,
	"./DocumentGenerateIcon.svg": 23184,
	"./DownArrow.svg": 8806,
	"./DownArrowBrown.svg": 19700,
	"./DownArrowTJRed.svg": 72543,
	"./DownloadButton.svg": 397,
	"./EditIcon.svg": 92190,
	"./ErrorIcon.svg": 27440,
	"./FacilitiesIconRed.svg": 36984,
	"./Filter.svg": 46119,
	"./GlossaryNoDataIcon.svg": 73235,
	"./GlossaryNoResultIcon.svg": 1440,
	"./GroupButtonBrown.svg": 42326,
	"./HamburgerIcon.svg": 57187,
	"./Handshake.svg": 9090,
	"./Help.svg": 29880,
	"./HelpIcon.svg": 28807,
	"./Home.svg": 37220,
	"./IdeaIcon.svg": 87567,
	"./ImportantIconRed.svg": 6951,
	"./ImportantIconSoftRed.svg": 79568,
	"./LeftArrow.svg": 20007,
	"./LeftArrowBlack.svg": 80318,
	"./LegacyIncompleteIcon.svg": 88911,
	"./LogisticsIconRed.svg": 35226,
	"./Management.svg": 48000,
	"./Members.svg": 62928,
	"./ModalCloseIcon.svg": 81331,
	"./MultiProductIcon.svg": 34526,
	"./MyNotes.svg": 91764,
	"./MyTasks.svg": 77453,
	"./NewSiteIcon.svg": 75825,
	"./NotFoundIcon.svg": 84927,
	"./Nutrition Facts.png": 87763,
	"./PackageIconRed.svg": 87833,
	"./PlusButtonRed.svg": 17544,
	"./PrepareForLaunch.svg": 7018,
	"./ProductDetail.svg": 7115,
	"./ProductPortalLogo.svg": 57295,
	"./ProductSizeIconRed.svg": 59647,
	"./RedDeleteButton.svg": 20809,
	"./ReportingAndAnalytics.svg": 50390,
	"./RetailStructureIconRed.svg": 21565,
	"./RetailTagIconRed.svg": 57516,
	"./RightArrow.svg": 62948,
	"./RightArrowBlack.svg": 99179,
	"./SalesIconRed.svg": 49745,
	"./Settings.svg": 20326,
	"./ShelfLifeIconRed.svg": 11167,
	"./StoreOrderability.svg": 58460,
	"./TJExportButtonRed.svg": 53976,
	"./TJHeaderLogo.svg": 15941,
	"./TastingPanel.svg": 34347,
	"./TjHeader.svg": 77648,
	"./TjLogo.svg": 37934,
	"./TjLogoCircle.svg": 82466,
	"./UiDateIcon.svg": 39960,
	"./UnAcceptableIcon.svg": 17735,
	"./UpArrow.svg": 3827,
	"./UpArrowRed.svg": 5182,
	"./VendorHeader.svg": 43148,
	"./VendorIcon.svg": 99856,
	"./VendorIconRed.svg": 19159,
	"./VendorManagement.svg": 56998,
	"./ViewIcon.svg": 62365,
	"./VolumeIconRed.svg": 51491,
	"./WarnigSignRed.svg": 21169,
	"./WhereAreFacilitiesIconRed.svg": 89855,
	"./cut.svg": 50129,
	"./dark-theme/ActiveProjects.svg": 39314,
	"./dark-theme/Add-Compound.svg": 88867,
	"./dark-theme/Copy.svg": 12497,
	"./dark-theme/CreateProduct.svg": 83729,
	"./dark-theme/DeleteIcon.svg": 29408,
	"./dark-theme/DesignArtwork.svg": 97398,
	"./dark-theme/DownArrow.svg": 16735,
	"./dark-theme/EditIcon.svg": 91337,
	"./dark-theme/Filter.svg": 88944,
	"./dark-theme/Hamburger.svg": 97509,
	"./dark-theme/Help.svg": 48259,
	"./dark-theme/Home.svg": 64679,
	"./dark-theme/Management.svg": 16831,
	"./dark-theme/MyNotes.svg": 87677,
	"./dark-theme/MyTasks.svg": 45212,
	"./dark-theme/PrepareForLaunch.svg": 98889,
	"./dark-theme/ProductDetail.svg": 25426,
	"./dark-theme/ReportingAndAnalytics.svg": 86303,
	"./dark-theme/Settings.svg": 36021,
	"./dark-theme/StoreOrderability.svg": 46401,
	"./dark-theme/TastingPanel.svg": 27232,
	"./dark-theme/VendorManagement.svg": 51893,
	"./dark-theme/cut.svg": 44060,
	"./dark-theme/redo.svg": 81374,
	"./dark-theme/regenerate.svg": 8088,
	"./dark-theme/save.svg": 13685,
	"./dark-theme/undo.svg": 81160,
	"./index": 10589,
	"./index.ts": 10589,
	"./multipleGroupsForContactlist.svg": 83162,
	"./multipleSitesForContactlist.svg": 48994,
	"./redo.svg": 41849,
	"./regenerate.svg": 46483,
	"./save.svg": 47806,
	"./undo.svg": 10355,
	"./upload-document-icon.svg": 66562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15524;